import axios from "axios";
import cogoToast from "cogo-toast";
import jwt from 'jsonwebtoken';
import JWT from "../models/users/JWT";

const publicRoutes = ['api/auth/login', 'api/auth/verify-2fa', 'api/auth/login/2fa', 'api/auth/send-email', 'api/auth/send-2fa-code', 'api/auth/recuperar-contrasena'];

export const requestInterceptor = (savePreviousLocationAndRedirectToLogin: () => void) => axios.interceptors.request.use((request) => {
    // const isAuthenticatedRoute = [
    //     'api/auth/setup-2fa',
    //     'api/auth/enable-2fa',
    //     'api/auth/confirm-2fa-setup',
    //     'api/auth/update-interval',
    //     'api/auth/regenerate-2fa',
    //     'api/users/disable-2fa'
    // ].some(route => request?.url?.includes(route));

    if (!publicRoutes.some(route => request?.url === route)) {
        const jsonwebtoken = localStorage.getItem('jwt');
        const isRespaldos = (request?.url || '').includes('api/respaldos');
        if (jsonwebtoken && (isRespaldos || (jwt.decode(jsonwebtoken) as JWT).exp > Date.now())) {
            request.headers = {
                ...request.headers,
                jwt: jsonwebtoken
            };
        } else {
            // if (isAuthenticatedRoute) {
            // }
            cogoToast.error('No autorizado - Por favor inicia sesión nuevamente');
            savePreviousLocationAndRedirectToLogin();
            return Promise.reject(new axios.Cancel("No autorizado"));
        }
    }
    return request;
})

export const responseInterceptor = () => axios.interceptors.response.use((response) => response, (error) => {
    if (error.status === 401 && !publicRoutes.some(route => error.config?.url === route)) {
        cogoToast.error('No autorizado - Por favor inicia sesión nuevamente');
    }
    if (error.status === 501) {
        cogoToast.error('No implementado');
    }
    return Promise.reject(error);
});

export const getAxiosBaseURL = (setCurrentAxiosBaseURL: (newAxiosBaseURL: string) => void, currentAxiosBaseURL?: string) => {
    const url = window.location.href.match(/^(https?:\/\/)?[^/\\: ]+/i);
    if (url && (!currentAxiosBaseURL || currentAxiosBaseURL !== url[0])) {
        setCurrentAxiosBaseURL(url[0]);
        axios.defaults.baseURL = `${url[0]}:${process.env.REACT_APP_BACKEND_PORT || "3001"}`;
    }
}